import styles from "./styles.module.scss";

export default function Anchor({ id }: { id: string }) {
	return <div className={styles.root} id={id} />;
}
